module.exports = __webpack_public_path__ + "static/media/noun-gallery.1abc9958.svg";